import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: Date; output: Date; }
  JSON: { input: any; output: any; }
};

export type Album = {
  __typename?: 'Album';
  dateEnd?: Maybe<Scalars['Date']['output']>;
  dateStart?: Maybe<Scalars['Date']['output']>;
  hasUnsortedImages?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  tags: Array<Tag>;
  userIds: Array<Scalars['String']['output']>;
};

export type AlbumCreateInput = {
  dateEnd?: InputMaybe<Scalars['Date']['input']>;
  dateStart?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AlbumUpdateInput = {
  dateEnd?: InputMaybe<Scalars['Date']['input']>;
  dateStart?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Image = {
  __typename?: 'Image';
  albumId: Scalars['String']['output'];
  exifData: Scalars['JSON']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secret: Scalars['String']['output'];
  tagsIds: Array<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type ImageTag = {
  __typename?: 'ImageTag';
  height: Scalars['Int']['output'];
  imageKey: Scalars['String']['output'];
  tagId: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type ListAlbumsResult = {
  __typename?: 'ListAlbumsResult';
  items: Array<Album>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ListImage = {
  __typename?: 'ListImage';
  fileName?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  screenUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width: Scalars['Int']['output'];
};

export type ListImagesResult = {
  __typename?: 'ListImagesResult';
  items: Array<ListImage>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Migration = {
  __typename?: 'Migration';
  id: Scalars['String']['output'];
  runAt: Scalars['DateTime']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createAlbum: Album;
  createTag: Album;
  deleteAlbum: Scalars['Boolean']['output'];
  deleteTag: Album;
  tagImage: Image;
  untagImage: Image;
  updateAlbum: Album;
  updateTag: Album;
};


export type MutationCreateAlbumArgs = {
  dto: AlbumCreateInput;
};


export type MutationCreateTagArgs = {
  albumId: Scalars['String']['input'];
  dto: TagInput;
};


export type MutationDeleteAlbumArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTagArgs = {
  albumId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationTagImageArgs = {
  albumId: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};


export type MutationUntagImageArgs = {
  albumId: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};


export type MutationUpdateAlbumArgs = {
  dto: AlbumUpdateInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateTagArgs = {
  albumId: Scalars['String']['input'];
  dto: TagInput;
  id: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  album: Album;
  albums: ListAlbumsResult;
  image: Image;
  images: ListImagesResult;
  tags: Array<Tag>;
};


export type QueryAlbumArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryAlbumsArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  startingToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryImageArgs = {
  albumId: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};


export type QueryImagesArgs = {
  albumSlug: Scalars['String']['input'];
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  startingToken?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTagsArgs = {
  albumId: Scalars['String']['input'];
};

export enum Role {
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
};

export type TagInput = {
  name: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
};

export type AlbumFragment = { __typename?: 'Album', id: string, name: string, dateStart?: any | null, dateEnd?: any | null, slug: string, password?: string | null, userIds: Array<string>, hasUnsortedImages?: boolean | null };

export type TagFragment = { __typename?: 'Tag', id: string, name: string, priority: number };

export type CreateAlbumMutationVariables = Exact<{
  dto: AlbumCreateInput;
}>;


export type CreateAlbumMutation = { __typename?: 'Mutation', createAlbum: { __typename?: 'Album', id: string, name: string, dateStart?: any | null, dateEnd?: any | null, slug: string, password?: string | null, userIds: Array<string>, hasUnsortedImages?: boolean | null } };

export type CreateTagMutationVariables = Exact<{
  albumId: Scalars['String']['input'];
  dto: TagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'Album', id: string, name: string, dateStart?: any | null, dateEnd?: any | null, slug: string, password?: string | null, userIds: Array<string>, hasUnsortedImages?: boolean | null } };

export type DeleteAlbumMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAlbumMutation = { __typename?: 'Mutation', deleteAlbum: boolean };

export type DeleteTagMutationVariables = Exact<{
  albumId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag: { __typename?: 'Album', id: string, name: string, dateStart?: any | null, dateEnd?: any | null, slug: string, password?: string | null, userIds: Array<string>, hasUnsortedImages?: boolean | null } };

export type UpdateAlbumMutationVariables = Exact<{
  id: Scalars['String']['input'];
  dto: AlbumUpdateInput;
}>;


export type UpdateAlbumMutation = { __typename?: 'Mutation', updateAlbum: { __typename?: 'Album', id: string, name: string, dateStart?: any | null, dateEnd?: any | null, slug: string, password?: string | null, userIds: Array<string>, hasUnsortedImages?: boolean | null } };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['String']['input'];
  albumId: Scalars['String']['input'];
  dto: TagInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'Album', id: string, name: string, dateStart?: any | null, dateEnd?: any | null, slug: string, password?: string | null, userIds: Array<string>, hasUnsortedImages?: boolean | null } };

export type GetAlbumQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAlbumQuery = { __typename?: 'Query', album: { __typename?: 'Album', id: string, name: string, dateStart?: any | null, dateEnd?: any | null, slug: string, password?: string | null, userIds: Array<string>, hasUnsortedImages?: boolean | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, priority: number }> } };

export type GetAlbumsQueryVariables = Exact<{
  startingToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAlbumsQuery = { __typename?: 'Query', albums: { __typename?: 'ListAlbumsResult', nextToken?: string | null, items: Array<{ __typename?: 'Album', id: string, name: string, dateStart?: any | null, dateEnd?: any | null, slug: string, password?: string | null, userIds: Array<string>, hasUnsortedImages?: boolean | null }> } };

export type GetTagsQueryVariables = Exact<{
  albumId: Scalars['String']['input'];
}>;


export type GetTagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', id: string, name: string, priority: number }> };

export type ImageFragment = { __typename?: 'Image', id: string, name: string, exifData: any, tagsIds: Array<string>, timestamp: string };

export type ListImageFragment = { __typename?: 'ListImage', id: string, url?: string | null, screenUrl?: string | null, thumbnailUrl?: string | null, fileName?: string | null, width: number, height: number };

export type TagImageMutationVariables = Exact<{
  imageId: Scalars['String']['input'];
  albumId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
}>;


export type TagImageMutation = { __typename?: 'Mutation', tagImage: { __typename?: 'Image', id: string, name: string, exifData: any, tagsIds: Array<string>, timestamp: string } };

export type UntagImageMutationVariables = Exact<{
  imageId: Scalars['String']['input'];
  albumId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
}>;


export type UntagImageMutation = { __typename?: 'Mutation', untagImage: { __typename?: 'Image', id: string, name: string, exifData: any, tagsIds: Array<string>, timestamp: string } };

export type GetImageQueryVariables = Exact<{
  albumId: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetImageQuery = { __typename?: 'Query', image: { __typename?: 'Image', id: string, name: string, exifData: any, tagsIds: Array<string>, timestamp: string } };

export type GetImagesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  startingToken?: InputMaybe<Scalars['String']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetImagesQuery = { __typename?: 'Query', images: { __typename?: 'ListImagesResult', nextToken?: string | null, items: Array<{ __typename?: 'ListImage', id: string, url?: string | null, screenUrl?: string | null, thumbnailUrl?: string | null, fileName?: string | null, width: number, height: number }> } };

export const AlbumFragmentDoc = gql`
    fragment Album on Album {
  id
  name
  dateStart
  dateEnd
  slug
  password
  userIds
  hasUnsortedImages
}
    `;
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  id
  name
  priority
}
    `;
export const ImageFragmentDoc = gql`
    fragment Image on Image {
  id
  name
  exifData
  tagsIds
  timestamp
}
    `;
export const ListImageFragmentDoc = gql`
    fragment ListImage on ListImage {
  id
  url
  screenUrl
  thumbnailUrl
  fileName
  width
  height
}
    `;
export const CreateAlbumDocument = gql`
    mutation CreateAlbum($dto: AlbumCreateInput!) {
  createAlbum(dto: $dto) {
    ...Album
  }
}
    ${AlbumFragmentDoc}`;
export type CreateAlbumMutationFn = Apollo.MutationFunction<CreateAlbumMutation, CreateAlbumMutationVariables>;

/**
 * __useCreateAlbumMutation__
 *
 * To run a mutation, you first call `useCreateAlbumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlbumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlbumMutation, { data, loading, error }] = useCreateAlbumMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateAlbumMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlbumMutation, CreateAlbumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlbumMutation, CreateAlbumMutationVariables>(CreateAlbumDocument, options);
      }
export type CreateAlbumMutationHookResult = ReturnType<typeof useCreateAlbumMutation>;
export type CreateAlbumMutationResult = Apollo.MutationResult<CreateAlbumMutation>;
export type CreateAlbumMutationOptions = Apollo.BaseMutationOptions<CreateAlbumMutation, CreateAlbumMutationVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($albumId: String!, $dto: TagInput!) {
  createTag(albumId: $albumId, dto: $dto) {
    ...Album
  }
}
    ${AlbumFragmentDoc}`;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      albumId: // value for 'albumId'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const DeleteAlbumDocument = gql`
    mutation DeleteAlbum($id: String!) {
  deleteAlbum(id: $id)
}
    `;
export type DeleteAlbumMutationFn = Apollo.MutationFunction<DeleteAlbumMutation, DeleteAlbumMutationVariables>;

/**
 * __useDeleteAlbumMutation__
 *
 * To run a mutation, you first call `useDeleteAlbumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlbumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlbumMutation, { data, loading, error }] = useDeleteAlbumMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlbumMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlbumMutation, DeleteAlbumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlbumMutation, DeleteAlbumMutationVariables>(DeleteAlbumDocument, options);
      }
export type DeleteAlbumMutationHookResult = ReturnType<typeof useDeleteAlbumMutation>;
export type DeleteAlbumMutationResult = Apollo.MutationResult<DeleteAlbumMutation>;
export type DeleteAlbumMutationOptions = Apollo.BaseMutationOptions<DeleteAlbumMutation, DeleteAlbumMutationVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($albumId: String!, $id: String!) {
  deleteTag(albumId: $albumId, id: $id) {
    ...Album
  }
}
    ${AlbumFragmentDoc}`;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      albumId: // value for 'albumId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const UpdateAlbumDocument = gql`
    mutation UpdateAlbum($id: String!, $dto: AlbumUpdateInput!) {
  updateAlbum(id: $id, dto: $dto) {
    ...Album
  }
}
    ${AlbumFragmentDoc}`;
export type UpdateAlbumMutationFn = Apollo.MutationFunction<UpdateAlbumMutation, UpdateAlbumMutationVariables>;

/**
 * __useUpdateAlbumMutation__
 *
 * To run a mutation, you first call `useUpdateAlbumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlbumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlbumMutation, { data, loading, error }] = useUpdateAlbumMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateAlbumMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlbumMutation, UpdateAlbumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlbumMutation, UpdateAlbumMutationVariables>(UpdateAlbumDocument, options);
      }
export type UpdateAlbumMutationHookResult = ReturnType<typeof useUpdateAlbumMutation>;
export type UpdateAlbumMutationResult = Apollo.MutationResult<UpdateAlbumMutation>;
export type UpdateAlbumMutationOptions = Apollo.BaseMutationOptions<UpdateAlbumMutation, UpdateAlbumMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($id: String!, $albumId: String!, $dto: TagInput!) {
  updateTag(albumId: $albumId, id: $id, dto: $dto) {
    ...Album
  }
}
    ${AlbumFragmentDoc}`;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      albumId: // value for 'albumId'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const GetAlbumDocument = gql`
    query getAlbum($slug: String!, $password: String) {
  album(slug: $slug, password: $password) {
    ...Album
    tags {
      id
      name
      priority
    }
  }
}
    ${AlbumFragmentDoc}`;

/**
 * __useGetAlbumQuery__
 *
 * To run a query within a React component, call `useGetAlbumQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlbumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlbumQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGetAlbumQuery(baseOptions: Apollo.QueryHookOptions<GetAlbumQuery, GetAlbumQueryVariables> & ({ variables: GetAlbumQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlbumQuery, GetAlbumQueryVariables>(GetAlbumDocument, options);
      }
export function useGetAlbumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlbumQuery, GetAlbumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlbumQuery, GetAlbumQueryVariables>(GetAlbumDocument, options);
        }
export function useGetAlbumSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAlbumQuery, GetAlbumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlbumQuery, GetAlbumQueryVariables>(GetAlbumDocument, options);
        }
export type GetAlbumQueryHookResult = ReturnType<typeof useGetAlbumQuery>;
export type GetAlbumLazyQueryHookResult = ReturnType<typeof useGetAlbumLazyQuery>;
export type GetAlbumSuspenseQueryHookResult = ReturnType<typeof useGetAlbumSuspenseQuery>;
export type GetAlbumQueryResult = Apollo.QueryResult<GetAlbumQuery, GetAlbumQueryVariables>;
export const GetAlbumsDocument = gql`
    query getAlbums($startingToken: String) {
  albums(startingToken: $startingToken) {
    items {
      ...Album
    }
    nextToken
  }
}
    ${AlbumFragmentDoc}`;

/**
 * __useGetAlbumsQuery__
 *
 * To run a query within a React component, call `useGetAlbumsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlbumsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlbumsQuery({
 *   variables: {
 *      startingToken: // value for 'startingToken'
 *   },
 * });
 */
export function useGetAlbumsQuery(baseOptions?: Apollo.QueryHookOptions<GetAlbumsQuery, GetAlbumsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlbumsQuery, GetAlbumsQueryVariables>(GetAlbumsDocument, options);
      }
export function useGetAlbumsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlbumsQuery, GetAlbumsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlbumsQuery, GetAlbumsQueryVariables>(GetAlbumsDocument, options);
        }
export function useGetAlbumsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAlbumsQuery, GetAlbumsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlbumsQuery, GetAlbumsQueryVariables>(GetAlbumsDocument, options);
        }
export type GetAlbumsQueryHookResult = ReturnType<typeof useGetAlbumsQuery>;
export type GetAlbumsLazyQueryHookResult = ReturnType<typeof useGetAlbumsLazyQuery>;
export type GetAlbumsSuspenseQueryHookResult = ReturnType<typeof useGetAlbumsSuspenseQuery>;
export type GetAlbumsQueryResult = Apollo.QueryResult<GetAlbumsQuery, GetAlbumsQueryVariables>;
export const GetTagsDocument = gql`
    query getTags($albumId: String!) {
  tags(albumId: $albumId) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *      albumId: // value for 'albumId'
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables> & ({ variables: GetTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const TagImageDocument = gql`
    mutation TagImage($imageId: String!, $albumId: String!, $tagId: String!) {
  tagImage(imageId: $imageId, albumId: $albumId, tagId: $tagId) {
    ...Image
  }
}
    ${ImageFragmentDoc}`;
export type TagImageMutationFn = Apollo.MutationFunction<TagImageMutation, TagImageMutationVariables>;

/**
 * __useTagImageMutation__
 *
 * To run a mutation, you first call `useTagImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagImageMutation, { data, loading, error }] = useTagImageMutation({
 *   variables: {
 *      imageId: // value for 'imageId'
 *      albumId: // value for 'albumId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useTagImageMutation(baseOptions?: Apollo.MutationHookOptions<TagImageMutation, TagImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagImageMutation, TagImageMutationVariables>(TagImageDocument, options);
      }
export type TagImageMutationHookResult = ReturnType<typeof useTagImageMutation>;
export type TagImageMutationResult = Apollo.MutationResult<TagImageMutation>;
export type TagImageMutationOptions = Apollo.BaseMutationOptions<TagImageMutation, TagImageMutationVariables>;
export const UntagImageDocument = gql`
    mutation UntagImage($imageId: String!, $albumId: String!, $tagId: String!) {
  untagImage(imageId: $imageId, albumId: $albumId, tagId: $tagId) {
    ...Image
  }
}
    ${ImageFragmentDoc}`;
export type UntagImageMutationFn = Apollo.MutationFunction<UntagImageMutation, UntagImageMutationVariables>;

/**
 * __useUntagImageMutation__
 *
 * To run a mutation, you first call `useUntagImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUntagImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [untagImageMutation, { data, loading, error }] = useUntagImageMutation({
 *   variables: {
 *      imageId: // value for 'imageId'
 *      albumId: // value for 'albumId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useUntagImageMutation(baseOptions?: Apollo.MutationHookOptions<UntagImageMutation, UntagImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UntagImageMutation, UntagImageMutationVariables>(UntagImageDocument, options);
      }
export type UntagImageMutationHookResult = ReturnType<typeof useUntagImageMutation>;
export type UntagImageMutationResult = Apollo.MutationResult<UntagImageMutation>;
export type UntagImageMutationOptions = Apollo.BaseMutationOptions<UntagImageMutation, UntagImageMutationVariables>;
export const GetImageDocument = gql`
    query getImage($albumId: String!, $imageId: String!, $password: String) {
  image(albumId: $albumId, imageId: $imageId, password: $password) {
    ...Image
  }
}
    ${ImageFragmentDoc}`;

/**
 * __useGetImageQuery__
 *
 * To run a query within a React component, call `useGetImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageQuery({
 *   variables: {
 *      albumId: // value for 'albumId'
 *      imageId: // value for 'imageId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGetImageQuery(baseOptions: Apollo.QueryHookOptions<GetImageQuery, GetImageQueryVariables> & ({ variables: GetImageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImageQuery, GetImageQueryVariables>(GetImageDocument, options);
      }
export function useGetImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImageQuery, GetImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImageQuery, GetImageQueryVariables>(GetImageDocument, options);
        }
export function useGetImageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetImageQuery, GetImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetImageQuery, GetImageQueryVariables>(GetImageDocument, options);
        }
export type GetImageQueryHookResult = ReturnType<typeof useGetImageQuery>;
export type GetImageLazyQueryHookResult = ReturnType<typeof useGetImageLazyQuery>;
export type GetImageSuspenseQueryHookResult = ReturnType<typeof useGetImageSuspenseQuery>;
export type GetImageQueryResult = Apollo.QueryResult<GetImageQuery, GetImageQueryVariables>;
export const GetImagesDocument = gql`
    query getImages($slug: String!, $password: String, $tagId: String, $startingToken: String, $itemsPerPage: Int) {
  images(
    albumSlug: $slug
    password: $password
    tagId: $tagId
    startingToken: $startingToken
    itemsPerPage: $itemsPerPage
  ) {
    items {
      ...ListImage
    }
    nextToken
  }
}
    ${ListImageFragmentDoc}`;

/**
 * __useGetImagesQuery__
 *
 * To run a query within a React component, call `useGetImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImagesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      password: // value for 'password'
 *      tagId: // value for 'tagId'
 *      startingToken: // value for 'startingToken'
 *      itemsPerPage: // value for 'itemsPerPage'
 *   },
 * });
 */
export function useGetImagesQuery(baseOptions: Apollo.QueryHookOptions<GetImagesQuery, GetImagesQueryVariables> & ({ variables: GetImagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImagesQuery, GetImagesQueryVariables>(GetImagesDocument, options);
      }
export function useGetImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImagesQuery, GetImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImagesQuery, GetImagesQueryVariables>(GetImagesDocument, options);
        }
export function useGetImagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetImagesQuery, GetImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetImagesQuery, GetImagesQueryVariables>(GetImagesDocument, options);
        }
export type GetImagesQueryHookResult = ReturnType<typeof useGetImagesQuery>;
export type GetImagesLazyQueryHookResult = ReturnType<typeof useGetImagesLazyQuery>;
export type GetImagesSuspenseQueryHookResult = ReturnType<typeof useGetImagesSuspenseQuery>;
export type GetImagesQueryResult = Apollo.QueryResult<GetImagesQuery, GetImagesQueryVariables>;